import React from "react";
import styled, { css } from "styled-components";
import { MantineAccordion } from "components/bootstrap";
const StyledPre = styled.pre(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.small};
  `
);
const DnsAdapterDocumentation = () => {
  const styleMarginBottom = { marginBottom: 10 };
  const aResponse = `{
  "single_value": "34.239.63.98",
  "multi_value": {
    "results": [
      {
        "ip_address": "34.239.63.98",
        "dns_ttl": 60
      },
      {
        "ip_address": "34.238.48.57",
        "dns_ttl": 60
      }
    ]
  },
  "ttl": 60000
}`;
  const aaaaResponse = `{
  "single_value": "2307:f8b0:3000:800:0:0:0:200e",
  "multi_value": {
    "results": [
      {
        "ip_address": "2307:f8b0:3000:800:0:0:0:200e",
        "dns_ttl": 77
      }
    ]
  },
  "ttl": 77000
}`;
  const aAndAaaaResponse = `{
  "single_value": "144.222.6.132",
  "multi_value": {
    "results": [
      {
        "ip_address": "144.222.6.132",
        "dns_ttl": 32,
        "ip_version": "IPv4"
      },
      {
        "ip_address": "1207:f8b1:6003:b01:0:0:0:8a",
        "dns_ttl": 299,
        "ip_version": "IPv6"
      }
    ]
  },
  "ttl": 32000
}`;
  const ptrResponse = `{
  "single_value": "c-45-216-65-41.hd1.fl.someisp.co.uk",
  "multi_value": {
    "domain": "someisp.co.uk",
    "full_domain": "c-45-216-65-41.hd1.fl.someisp.co.uk",
    "dns_ttl": "300",
  },
  "ttl": 300000
}`;
  const txtResponse = `{
  "single_value": null,
  "multi_value": {
    "results": [
      {
        "value": "Some text value that lives in a TXT DNS",
        "dns_ttl": 300
      },
      {
        "value": "v=spf1 include:some-email-domain.org ~all.",
        "dns_ttl": 200
      }
    ]
  },
  "ttl": 200000
}`;
  const accordionItems = [
    {
      value: "ipv4",
      label: "Resolve hostname to IPv4 address (A)",
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "Returns both a ", /* @__PURE__ */ React.createElement("code", null, "single_value"), " containing one of the IPv4 addresses that the hostname resolves to, and a ", /* @__PURE__ */ React.createElement("code", null, "multi_value"), " containing all IPv4 addresses that the hostname resolves to. Input for this type must be a pure domain name (eg. ", /* @__PURE__ */ React.createElement("code", null, "api.example.com"), ")."), /* @__PURE__ */ React.createElement(StyledPre, null, aResponse))
    },
    {
      value: "ipv6",
      label: "Resolve hostname to IPv6 address (AAAA)",
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "Returns both a ", /* @__PURE__ */ React.createElement("code", null, "single_value"), " containing one of the IPv6 addresses that the hostname resolves to, and a ", /* @__PURE__ */ React.createElement("code", null, "multi_value"), " containing all IPv6 addresses that the hostname resolves to. Input for this type must be a pure domain name (eg. ", /* @__PURE__ */ React.createElement("code", null, "api.example.com"), ")."), /* @__PURE__ */ React.createElement(StyledPre, null, aaaaResponse))
    },
    {
      value: "ipv4&ipv6",
      label: "Resolve hostname to IPv4 and IPv6 address (A and AAAA)",
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "Returns both a ", /* @__PURE__ */ React.createElement("code", null, "single_value"), " containing one of the IPv4 or IPv6 addresses that the hostname resolves to (will return IPv4 if available), and a ", /* @__PURE__ */ React.createElement("code", null, "multi_value"), " containing all IPv4 and IPv6 addresses that the hostname resolves to. Input for this type must be a pure domain name (eg.", " ", /* @__PURE__ */ React.createElement("code", null, "api.example.com"), ")."), /* @__PURE__ */ React.createElement(StyledPre, null, aAndAaaaResponse))
    },
    {
      value: "ptr",
      label: "Reverse lookup (PTR)",
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "Returns a ", /* @__PURE__ */ React.createElement("code", null, "single_value"), " containing the PTR value if defined for the IP address. The", " ", /* @__PURE__ */ React.createElement("code", null, "domain"), " field displays the domain name (with no subdomains). The ", /* @__PURE__ */ React.createElement("code", null, "full_domain"), " field displays the full un-trimmed host name/PTR value. The input for this type must be a pure IPv4 or IPv6 address (eg. ", /* @__PURE__ */ React.createElement("code", null, "10.0.0.1"), " or ", /* @__PURE__ */ React.createElement("code", null, "2622:f3b0:4000:812::200c"), ")."), /* @__PURE__ */ React.createElement(StyledPre, null, ptrResponse))
    },
    {
      value: "txt",
      label: "Text lookup (TXT)",
      content: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "Returns a ", /* @__PURE__ */ React.createElement("code", null, "multi_value"), " with all TXT records defined for the hostname. Input for this type must be a pure domain name (eg. ", /* @__PURE__ */ React.createElement("code", null, "api.example.com"), ")."), /* @__PURE__ */ React.createElement(StyledPre, null, txtResponse))
    }
  ];
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", { style: styleMarginBottom }, "Configuration"), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, "DNS Lookup Type"), /* @__PURE__ */ React.createElement(MantineAccordion, { accordionItems, defaultValue: "ipv4" }), /* @__PURE__ */ React.createElement("hr", null), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, "DNS Server IP Addresses"), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "A comma-separated list of DNS server IP addresses and optional ports to use (eg.", " ", /* @__PURE__ */ React.createElement("code", null, "192.168.1.1:5353, 192.168.1.244"), "). Leave this blank to use the DNS server defined for your local system. All requests use port 53 unless otherwise specified."), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, "DNS Request Timeout"), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "The DNS request timeout in milliseconds."), /* @__PURE__ */ React.createElement("h5", { style: styleMarginBottom }, "Cache TTL Override"), /* @__PURE__ */ React.createElement("p", { style: styleMarginBottom }, "If enabled, the TTL for this adapter's cache will be overridden with the specified value."));
};
export default DnsAdapterDocumentation;
